<template>
	<div class="save-temp pl20 pr20">
		<p><span class="label text-bold">覆盖模板：</span>输入模板名称搜索，选择已有模板后保存会覆盖原模板。</p>
		<p><span class="label text-bold">保存新模板：</span>输入一个不存在的模板名称，点击保存，即保存为新模板。</p>
		<div class="mt20 temp-name">
			<el-popover
				ref="popover"
				placement="bottom-start"
				width="420"
				popper-class="popper-nopadding"
				:value="!!list.length"
				trigger="manual">
				<div  class="name-list">
					<div 
						v-for="item in list"
						:key="item.id"
						class="name-list-item"
						@click="updateTempName(item)"
					>
						{{ item.name }}
					</div>
				</div>
				<el-input 
					slot="reference" 
					style="width:420px" 
					clearable 
					:value="inputData"
					@blur="handleBlur"  
					@focus="handleFocus"
					@input="handleInput" 
					placeholder="请输入模板名称" 
				 />
			</el-popover>
			<span class="num pl10">{{inputData.length}}/35</span>
		</div>
		
		<div class="tac mt50">
			<el-button @click="$emit('close')"><span class="ml20 mr20" >取消</span></el-button>
			<el-button  type="primary" @click="handleOnSubmit"><span class="ml20 mr20">保存</span></el-button>
		</div>
		
	</div>
</template>

<script>
import { debounce } from 'lodash'
import { getMaterialTempListApi } from '@/api'
export default {
	props: [ 'cbs', 'defaultParams' ],
	data() {
		return {
			inputData: '',
			list: [],
			otherParams: {},
			cacheList: []
		}
	},
	methods: {
		async handleBlur() {
			setTimeout(()=> {
				this.cacheList = this.list;
				this.list = []
			}, 300)
		},
		async handleFocus() {
			
			this.list = this.cacheList;
			this.cacheList = []
		},
		updateTempName(item) {
			this.inputData = item.name;
			this.otherParams = {
				id: item.id,
			};
			this.list = [];
		},
		handleInput(data) {
			
			this.otherParams = {}
			
			if (!data) {
				this.inputData = data;
				this.list = [];
				return;
			};
			const input = data.substring(0,35);
			this.inputData = input;
			this.searchTempList(input)

		},
		searchTempList: debounce(async function(search) {
			const params = {
				...this.defaultParams,
				search,
				all: '1'
			}
			const { data } = await getMaterialTempListApi(params);
			this.list = data;
		}, 100),
		handleOnSubmit() {
			this.cbs.onSubmit(this.inputData, { ...this.otherParams })
		}
	}
}
</script>
<style>
.popper-nopadding {
	padding: 0;
}
</style>
<style lang="scss" scoped>
.save-temp {
	font-size: 12px;
	.temp-name {
		display: flex;
		.num {
			width: 50px;
			line-height: 30px;
			font-size: 14px;
		}
	}
}
.name-list {
	padding: 10px 0;
	&-item {
		padding: 8px 20px;
		font-size: 14px;
		cursor: pointer;
		&:hover {
			background: #f3f3f3;
		}
	}
}

</style>